module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.snowflake.title":"Snowflake Cloud Connections","settings.snowflake.subtitle":"All cloud connections importing Snowflake usage data in this tenant."}}')
  delete Component.options._Ctor
}
